export const GET_GATE_ENTRIES_BY_ID = "GET_GATE_ENTRIES_BY_ID";
export const GET_GATE_ENTRIES_BY_ID_SUCCESS = "GET_GATE_ENTRIES_BY_ID_SUCCESS";
export const GET_GATE_ENTRIES_BY_ID_FAILED = "GET_GATE_ENTRIES_BY_ID_FAILED";

export const GET_ALL_GATE_ENTRIES = "GET_ALL_GATE_ENTRIES";
export const GET_ALL_GATE_ENTRIES_SUCCESS = "GET_ALL_GATE_ENTRIES_SUCCESS";
export const GET_ALL_GATE_ENTRIES_FAILED = "GET_ALL_GATE_ENTRIES_FAILED";

export const UPDATE_GATE_ENTRY = "UPDATE_GATE_ENTRY";
export const UPDATE_GATE_ENTRY_SUCCESS = "UPDATE_GATE_ENTRY_SUCCESS";
export const UPDATE_GATE_ENTRY_FAILED = "UPDATE_GATE_ENTRY_FAILED";

export const CREATE_GATE_ENTRY = "CREATE_GATE_ENTRY";
export const CREATE_GATE_ENTRY_SUCCESS = "CREATE_GATE_ENTRY_SUCCESS";
export const CREATE_GATE_ENTRY_FAILED = "CREATE_GATE_ENTRY_FAILED";